import { api } from './api.js';
import { setState } from './state.js';
import { addRoute, setFallback, start } from './router.js';
import { renderNav } from './components/nav.js';
import { renderGraphView } from './views/graphView.js';
import { renderConceptView } from './views/conceptView.js';
import { renderAuthView } from './views/authView.js';
import { renderNotFoundView } from './views/notFoundView.js';
import { renderAdminView } from './views/adminView.js';
import { renderAboutView } from './views/aboutView.js';
import { renderTreeView } from './views/treeView.js';
import { renderTimelineView } from './views/timelineView.js';
import { renderFlowView } from './views/flowView.js';
import { renderFlowsListView } from './views/flowsListView.js';
import { renderRecentView } from './views/recentView.js';
import { STORAGE_KEYS, isStandalone } from './config.js';
import { loadUITranslations } from './lib/i18n.js';

const appEl = document.getElementById('app')!;
const navEl = document.getElementById('nav')!;

// Redirect legacy hash URLs (e.g. /app.html#/graph → /graph)
if (!isStandalone() && window.location.hash.startsWith('#/')) {
  const cleanPath = window.location.hash.slice(1);
  history.replaceState({}, '', cleanPath);
}

// Check session on load
async function init(): Promise<void> {
  // Restore saved language preference
  const savedLang = localStorage.getItem(STORAGE_KEYS.LANG);
  if (savedLang) setState({ lang: savedLang });

  // Load UI translations
  await loadUITranslations();

  if (!isStandalone()) {
    try {
      const { user } = await api.me() as { user: { id: number; username: string; is_admin: number } | null };
      if (user) setState({ user });
    } catch (err) {
      console.warn('Session check failed:', (err as Error).message);
    }
  }

  renderNav(navEl);

  // Register routes
  addRoute('/graph', () => renderGraphView(appEl));
  addRoute('/concept/:slug', (params) => renderConceptView(appEl, params.slug));
  addRoute('/tree', () => renderTreeView(appEl));
  addRoute('/timeline', () => renderTimelineView(appEl));
  addRoute('/flow', () => renderFlowsListView(appEl));
  addRoute('/flow/:slug', (params) => renderFlowView(appEl, params.slug));
  addRoute('/recent', () => renderRecentView(appEl));
  addRoute('/about', () => renderAboutView(appEl));

  if (!isStandalone()) {
    addRoute('/login', () => renderAuthView(appEl));
    addRoute('/admin', () => renderAdminView(appEl));
  }

  setFallback(() => renderNotFoundView(appEl));

  start();
}

init().catch(err => console.error('App failed to initialize:', err));
